'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _reportForm = require('./report-form.component');

var _reportForm2 = _interopRequireDefault(_reportForm);

require('./report-form.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.reports.reportForm', []).component('reportForm', _reportForm2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/reports/report-form/report-form.module.js